define((require) => {
    "use strict";

    var ImprovedView = require("editor/zbone/ImprovedView"),
        template     = require("ui/experience/widgets/salesforceCommerceWidget/action/SalesforceCommerceQuickViewActionPropertiesView.tpl");

    /**
     * Properties view for a SalesforceCommerce QuickView action.
     *
     * @class SalesforceCommerceActionPropertiesView
     * @constructor
     *
     * @cfg {SalesforceCommerceQuickViewAction} model - The action to display in the view.
     */
    return ImprovedView.extend({
        template: template,

        bindings: {
            ".productID": "productID"
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/salesforceCommerceWidget/action/SalesforceCommerceQuickViewActionPropertiesView.js